import { Component } from '@angular/core';
import { StateService } from '../../../services/common/claim-year.service';
import { CommonService } from '../../../services/common/common.service';
import { ApiUrlHelper } from '../../../common/api-url-helper';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '../../../services/common/validation-service';
import {
  ClaimByProject,
  commonLabelConstants,
} from '../../../constants/label-constants';
import { SharedService } from '../../../services/shared-service/shared.service';
import { environment } from '../../../../environments/environment';
import { CommonErrorMessages } from '../../../constants/error-messages';
import { ClaimWorkFlowItemStatusDropDownService } from '../../../services/common/claim-work-flow-item-status-drop-down.service';
import { ToastrService } from 'ngx-toastr';
import { RoleRightsService } from '../../../services/common/role-rights.service';
import { Subject, takeUntil } from 'rxjs';
import { StorageService } from '../../../services/storage/storage.service';
import { HttpResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { TooltipModalComponent } from '../../tooltip/tooltip-modal/tooltip-modal.component';

@Component({
  selector: 'app-claim-by-project',
  templateUrl: './claim-by-project.component.html',
  styleUrl: './claim-by-project.component.scss',
})
export class ClaimByProjectComponent {
  havePermission: boolean = false;
  menuId: number = 0;
  env: any = environment;
  submitted: boolean = false;
  companyId: any;
  claimYearId: any;
  projectList: any;
  ClaimForm!: FormGroup;
  isLoading: boolean = false;
  ClaimByProjectList: any;
  staffingCost: number = 0;
  epwUnConnected: number = 0;
  epwConnected: number = 0;
  subContractorUnConnected: number = 0;
  subContractorConnected: number = 0;
  onDestroy$: Subject<void> = new Subject();
  software: number = 0;
  dataLicence: number = 0;
  utilityCost: number = 0;
  paymentsToClinicalTrialParticipants: number = 0;
  cloudComputing: number = 0;
  consumableItem: number = 0;
  totalList: any[] = [];
  projectTotal: any;
  ProjectWiseList: any[] = [];
  finalTotal: any;
  Projecttotal: any;
  labelConstants = ClaimByProject;
  commonLabelConstants = commonLabelConstants;
  commonErrorMessages = CommonErrorMessages;
  isLocked: boolean = false;
  claimWorkFlowItemStatusList: any[] = [];
  claimWorkFlowItemStatus: any;
  claimWorkflowItemStatusId: any;

  constructor(
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    private readonly sharedDataService: StateService,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly sharedService: SharedService,
    private readonly claimWorkFlowItemStatusService: ClaimWorkFlowItemStatusDropDownService,
    private readonly fb: FormBuilder,
    private readonly validationService: ValidationService,
    private readonly roleRightsService: RoleRightsService,
    private readonly storageService: StorageService,
    private readonly dialog: MatDialog
  ) {
    this.ClaimForm = this.fb.group({
      Projecttotal: [{ value: '', disabled: true }], // For total input
    });
  }

  async ngOnInit() {
    this.roleRightsService.hasAccess('isAdd');
    this.sharedService.setData(this.labelConstants.ClaimByProjectheader);
    this.sharedDataService.companyId$.subscribe((companyId) => {
      this.companyId = companyId;
    });

    this.sharedDataService.yearId$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(async (yearId) => {
        this.claimYearId = yearId ?? null;
        if (this.companyId && this.claimYearId) {
          await this.GetProjectListCompanyWise(
            this.companyId,
            this.claimYearId
          );
          this.GetClaimByProject(this.companyId, this.claimYearId);
          this.projectList.forEach((_: any, index: string) => {
            this.ClaimForm.addControl(
              'ProjectAmount_' + index,
              this.fb.control('', [Validators.pattern('^[0-9]*$')])
            );
          });

          this.projectList.forEach((_: any, index: string) => {
            this.ClaimForm.get(
              'ProjectAmount_' + index
            )?.valueChanges.subscribe(() => {
              this.calculateTotal();
            });
          });
        }
        this.sharedService.gethavePermission().subscribe(async (data) => {
          this.havePermission = data;
          if (!this.isLocked) {
            this.havePermission
              ? this.ClaimForm.enable()
              : this.ClaimForm.disable();
            this.ClaimForm.get('Projecttotal')?.disable();
          }
        });
        this.claimWorkFlowItemStatusList =
          this.claimWorkFlowItemStatusService.getClaimWorkFlowItemStatus();
      });
  }

  async GetProjectListCompanyWise(
    companyId: any,
    claimYearId: any
  ): Promise<any> {
    if (!this.storageService.getValue('authToken')) {
      return;
    }
    this.isLoading = true;
    let api = this.api.apiUrl.Project.GetProjectListWithOutPagination.replace(
      '{companyId}',
      companyId
    ).replace('{claimYearId}', claimYearId);

    return new Promise((resolve, reject) => {
      this.commonService
        .doGet(api)
        .pipe()
        .subscribe({
          next: (response) => {
            if (response.success) {
              this.projectList = response.data;
              this.isLoading = false;
              resolve(this.projectList);
            } else {
              this.projectList = [];
              this.isLoading = false;
              reject(new Error('No data available'));
            }
          },
          error: (error: any) => {
            console.log(error);
            this.isLoading = false;
            reject(error);
          },
          complete: () => {},
        });
    });
  }

  GetClaimByProject(companyId: any, claimYearId: any) {
    this.isLoading = true;
    const segments = this.router.url.split('/');
    var lastSegment = segments.pop() ?? '';
    let api = this.api.apiUrl.Claim.GetClaimByProject;

    var model = {
      companyId: companyId,
      claimYearId: claimYearId,
      url: lastSegment,
    };

    this.commonService
      .doPost(api, model)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.success) {
            if (response.data[0].projectId === 0) {
              this.isLocked = response.data[0]?.isLocked ?? false;
              this.claimWorkFlowItemStatus =
                response.data[0]?.itemStatusId ?? 0;
              this.claimWorkflowItemStatusId =
                response.data[0]?.claimWorkflowItemStatusId ?? 0;
              this.menuId = response.data[0]?.menuId ?? 0;
              this.ClaimByProjectList = [];
              this.projectList = [];
              this.calculateTotals();
            } else {
              this.ClaimByProjectList = response.data;
              this.isLocked = response.data[0]?.isLocked ?? false;
              this.setQIAAmounts(this.ClaimByProjectList);
              this.isLoading = false;
              this.calculateTotals();
              this.claimWorkFlowItemStatus =
                this.ClaimByProjectList[0]?.itemStatusId ?? 0;
              this.claimWorkflowItemStatusId =
                this.ClaimByProjectList[0]?.claimWorkflowItemStatusId ?? 0;
              this.menuId = this.ClaimByProjectList[0]?.menuId;
            }
          } else {
            this.projectList = [];
          }
        },
        error: (error: any) => {
          console.log(error);
          this.isLoading = false;
        },
        complete: () => {
          if (this.isLocked) {
            this.ClaimForm.disable();
          } else {
            if (this.havePermission) {
              this.ClaimForm.enable();
            }
          }
          this.ClaimForm.get('Projecttotal')?.disable();
          this.isLoading = false;
        },
      });
  }

  setQIAAmounts(claimByProjectAmounts: any[]) {
    claimByProjectAmounts.forEach((amount) => {
      const index = this.projectList.findIndex(
        (project: { projectId: any }) => project.projectId === amount.projectId
      );
      if (index !== -1) {
        this.ClaimForm.get('ProjectAmount_' + index)?.setValue(
          amount.qiaAmount
        );
      }
    });
  }

  goBack(): void {
    this.router.navigateByUrl('/claim-workflow');
  }

  calculateTotals() {
    this.ProjectWiseList = [];
    this.staffingCost = this.ClaimByProjectList.reduce(
      (sum: number, current: { staffingCost?: number }) =>
        sum + (current.staffingCost ?? 0),
      0
    );
    this.epwUnConnected = this.ClaimByProjectList.reduce(
      (sum: number, current: { epwUnConnected?: number }) =>
        sum + (current.epwUnConnected ?? 0),
      0
    );
    this.epwConnected = this.ClaimByProjectList.reduce(
      (sum: number, current: { epwConnected?: number }) =>
        sum + (current.epwConnected ?? 0),
      0
    );
    this.subContractorUnConnected = this.ClaimByProjectList.reduce(
      (sum: number, current: { subContractorUnConnected?: number }) =>
        sum + (current.subContractorUnConnected ?? 0),
      0
    );
    this.subContractorConnected = this.ClaimByProjectList.reduce(
      (sum: number, current: { subContractorConnected?: number }) =>
        sum + (current.subContractorConnected ?? 0),
      0
    );
    this.software = this.ClaimByProjectList.reduce(
      (sum: number, current: { software?: number }) =>
        sum + (current.software ?? 0),
      0
    );
    this.dataLicence = this.ClaimByProjectList.reduce(
      (sum: number, current: { dataLicence?: number }) =>
        sum + (current.dataLicence ?? 0),
      0
    );
    this.cloudComputing = this.ClaimByProjectList.reduce(
      (sum: number, current: { cloudComputing?: number }) =>
        sum + (current.cloudComputing ?? 0),
      0
    );
    this.consumableItem = this.ClaimByProjectList.reduce(
      (sum: number, current: { consumableItem?: number }) =>
        sum + (current.consumableItem ?? 0),
      0
    );
    this.utilityCost = this.ClaimByProjectList.reduce(
      (sum: number, current: { utilityCost?: number }) =>
        sum + (current.utilityCost ?? 0),
      0
    );
    this.paymentsToClinicalTrialParticipants = this.ClaimByProjectList.reduce(
      (
        sum: number,
        current: { paymentsToClinicalTrialParticipants?: number }
      ) => sum + (current.paymentsToClinicalTrialParticipants ?? 0),
      0
    );
    this.projectList.forEach((element: { projectId: any }) => {
      const projectData = this.ClaimByProjectList.find(
        (project: { projectId: any }) => project.projectId === element.projectId
      );
      if (projectData) {
        this.projectTotal =
          (projectData.staffingCost ?? 0) +
          (projectData.epwUnConnected ?? 0) +
          (projectData.epwConnected ?? 0) +
          (projectData.subContractorUnConnected ?? 0) +
          (projectData.subContractorConnected ?? 0) +
          (projectData.software ?? 0) +
          (projectData.dataLicence ?? 0) +
          (projectData.cloudComputing ?? 0) +
          (projectData.consumableItem ?? 0) +
          (projectData.utilityCost ?? 0) +
          (projectData.paymentsToClinicalTrialParticipants ?? 0);
      } else {
        this.projectTotal = 0;
      }

      this.ProjectWiseList.push({
        total: this.projectTotal,
      });
    });

    this.finalTotal =
      this.staffingCost +
      this.epwUnConnected +
      this.epwConnected +
      this.subContractorUnConnected +
      this.subContractorConnected +
      this.software +
      this.dataLicence +
      this.cloudComputing +
      this.consumableItem +
      this.utilityCost +
      this.paymentsToClinicalTrialParticipants;
  }

  calculateTotal() {
    this.Projecttotal = 0;
    this.projectList.forEach((_: any, index: string) => {
      const value = this.ClaimForm.get('ProjectAmount_' + index)?.value;
      if (value) {
        this.Projecttotal += parseFloat(value);
      }
    });
  }

  save() {
    if (this.isLocked) {
      this.toastr.error(this.commonErrorMessages.ClaimLocked);
      return;
    }
    if (!this.havePermission) {
      this.toastr.error(this.commonErrorMessages.ActionNotPermitted);
      return;
    }
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    this.submitted = true;
    if (this.ClaimForm.valid) {
      this.isLoading = true;
      let api = this.api.apiUrl.Claim.SaveClaimByProjectAmount;
      const claimByProjectAmounts = this.projectList.map(
        (project: { projectId: any }, index: string) => {
          return {
            projectId: project.projectId,
            qiaAmount:
              this.ClaimForm.get('ProjectAmount_' + index)?.value != '' &&
              this.ClaimForm.get('ProjectAmount_' + index)?.value != null
                ? this.ClaimForm.get('ProjectAmount_' + index)?.value
                : 0,
          };
        }
      );
      const formData = {
        CompanyId: this.companyId,
        ClaimYearId: this.claimYearId,
        claimByProjectAmounts,
      };
      this.commonService
        .doPost(api, formData)
        .pipe()
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            if (response.success) {
              this.toastr.success(response.message);
              this.GetClaimByProject(this.companyId, this.claimYearId);
              this.isLoading = false;
            } else {
              this.toastr.error(response.message);
              this.isLoading = false;
            }
          },
          error: (error: any) => {
            this.isLoading = false;
            console.log(error);
          },
          complete: () => {
            this.isLoading = false;
          },
        });
    }
  }
  claimWorkFlowItemStatusChange(event: any) {
    if (this.isLocked) {
      this.toastr.error(this.commonErrorMessages.ClaimLocked);
      return;
    }
    if (!this.havePermission) {
      this.toastr.error(this.commonErrorMessages.ActionNotPermitted);
      return;
    }
    const payload = {
      ClaimWorkflowItemStatusId: this.claimWorkflowItemStatusId ?? 0,
      MenuId: this.menuId ?? 0,
      ClaimYearId: this.claimYearId ?? 0,
      CompanyId: this.companyId ?? 0,
      ItemStatusId: event.id,
      UserId: 0,
    };
    const validatePayload = (payload: any): string | null => {
      switch (true) {
        case payload.ClaimYearId === 0:
          return this.commonErrorMessages.YearRequired;
        case payload.CompanyId === 0:
          return this.commonErrorMessages.CompanyRequired;
        default:
          return null;
      }
    };
    const validationMessage = validatePayload(payload);
    if (validationMessage) {
      this.toastr.error(validationMessage);
      return;
    }
    let api = this.api.apiUrl.Claim.SaveClaimWorkFlowItemStatus;
    this.commonService.doPost(api, payload).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.toastr.success(response.message);
        } else {
          this.toastr.success(response.message);
        }
      },
      error: (err) => {},
      complete: () => {
        if (this.companyId && this.claimYearId) {
          this.GetClaimByProject(this.companyId, this.claimYearId);
        }
      },
    });
  }
  getStatus(itemStatusId: any) {
    const status =
      this.claimWorkFlowItemStatusService.getClaimWorkFlowItemStatusById(
        itemStatusId
      );
    return status[0]?.class;
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  export(){
    const isValid = this.validationService.validateCompanyAndYear(
      this.companyId,
      this.claimYearId
    );
    if (!isValid) {
      return;
    }
    const companyIdStr = this.companyId !== null ? String(this.companyId) : '';
    const yearIdStr = this.claimYearId !== null ? String(this.claimYearId) : '';
    let obj = {
      CompanyId: companyIdStr,
      ClaimYearId: yearIdStr,
      Url : "/claim-by-project"
    };
    let api = this.api.apiUrl.Claim.ExportClaimByProject;
    this.commonService.doDownloadPost(api, obj).subscribe(
      (response: HttpResponse<Blob>) => {
        const blob = response.body as Blob;
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = "Summary of Claim by Project.xlsx";

        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  opanPreviewModal(tooltipid:any,tooltipName:any){
    const dialogRef = this.dialog.open(TooltipModalComponent, {
      width: '900px',
      data:{id:tooltipid,IsPreview:true,name:tooltipName},
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result === true) {

      }
    });
  }
}
